module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-custom-menu nt-bell-wrap"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown notifications-menu",
    class: {
      open: _vm.open
    }
  }, [_c('a', {
    staticClass: "nt-bell",
    attrs: {
      "href": "#",
      "title": _vm.statusTitle
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), (_vm.center.unread) ? _c('span', {
    staticClass: "label nt-bell-count"
  }, [_vm._v(_vm._s(_vm.center.unread > 99 ? '99+' : _vm.center.unread))]) : _vm._e()]), _vm._v(" "), (_vm.open) ? _c('ul', {
    staticClass: "dropdown-menu nt-bell-menu"
  }, [_c('li', {
    staticClass: "header nt-bell-head"
  }, [_c('span', [_vm._v("Notifications")]), _vm._v(" "), (_vm.center.unread) ? _c('a', {
    staticClass: "nt-bell-readall",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.readAll.apply(null, arguments)
      }
    }
  }, [_vm._v("Mark all read")]) : _vm._e()]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "menu nt-bell-list"
  }, [(_vm.center.loading && !_vm.center.items.length) ? _c('li', {
    staticClass: "nt-bell-empty"
  }, [_vm._v("Loading…")]) : (!_vm.center.items.length) ? _c('li', {
    staticClass: "nt-bell-empty"
  }, [_vm._v("No notifications yet.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.recent), function(n) {
    return _c('li', {
      key: n.id,
      staticClass: "nt-bell-item",
      class: {
        'nt-unread': !n.is_read
      },
      on: {
        "click": function($event) {
          return _vm.openItem(n)
        }
      }
    }, [_c('i', {
      staticClass: "fa nt-bell-icon",
      class: [_vm.icon(n), ("nt-sev-" + (n.severity))]
    }), _vm._v(" "), _c('div', {
      staticClass: "nt-bell-text"
    }, [_c('strong', [_vm._v(_vm._s(n.title))]), _vm._v(" "), (n.body) ? _c('span', {
      staticClass: "nt-bell-body"
    }, [_vm._v(_vm._s(n.body))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "nt-bell-time"
    }, [_vm._v(_vm._s(_vm.ago(n.created_at)))])])])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/notifications"
    },
    nativeOn: {
      "click": function($event) {
        _vm.open = false
      }
    }
  }, [_vm._v("View all notifications")])], 1)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-56402f26","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationBell.vue
// module id = 2SxC
// module chunks = 1